import React, { useEffect } from 'react';

export default function DiscordCallback() {
  useEffect(() => {
    // Získej code z URL
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const error = urlParams.get('error');

    if (error) {
      console.error('❌ Discord OAuth error:', error);
      // Zavři okno a pošli error do parent window
      if (window.opener) {
        window.opener.postMessage({
          type: 'discord-oauth-callback',
          error: error
        }, window.location.origin);
      }
      window.close();
      return;
    }

    if (code) {
      console.log('✅ Discord OAuth code received');
      // Pošli code do parent window
      if (window.opener) {
        window.opener.postMessage({
          type: 'discord-oauth-callback',
          code: code
        }, window.location.origin);
      }
      // Callback page se zavře automaticky po zpracování v parent window
    } else {
      console.error('❌ No code received from Discord');
      window.close();
    }
  }, []);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      backgroundColor: '#5865F2',
      color: 'white',
      fontFamily: 'sans-serif',
      textAlign: 'center',
      padding: '20px'
    }}>
      <div>
        <div style={{ fontSize: '48px', marginBottom: '20px' }}>💬</div>
        <h2>Přihlašování k Discord...</h2>
        <p>Toto okno se automaticky zavře.</p>
      </div>
    </div>
  );
}
